<template>
    <div class="navMenu">
        <template v-for="navMenu in navMenus">
            <!-- 最后一级菜单 -->
            <el-menu-item
                    v-if="(!navMenu.children || navMenu.children.length === 0 ) && navMenu.name && navMenu.meta.icon
                    && (code === '4' || (navMenu.meta.hasPermission && code !== '4' ))"
                    :key="navMenu.meta.id" :data="navMenu.name" @click="clearParam"
                    :index="navMenu.meta.basePath ? navMenu.meta.basePath + '/' + navMenu.path : navMenu.path"
                    :route="navMenu.meta.basePath ? navMenu.meta.basePath + '/' + navMenu.path : navMenu.path"
            >
                <i :class="navMenu.meta.icon"></i>
                <span slot="title">{{navMenu.meta.title}}</span>
            </el-menu-item>

            <!-- 此菜单下还有子菜单 -->
            <el-submenu v-if="navMenu.children && navMenu.children.length > 0 && navMenu.name
                        && (code === '4' || (navMenu.meta.hasPermission && code !== '4' ))"
                        :key="navMenu.meta.id" :data="navMenu.name" :index="navMenu.name">
                <template slot="title">
                    <i :class="navMenu.meta.icon"></i>
                    <span>{{navMenu.meta.title}}</span>
                </template>
                <!-- 递归 -->
                <NavMenu :navMenus="navMenu.children"></NavMenu>
            </el-submenu>
        </template>
    </div>
</template>

<script>
    export default {
        name: 'NavMenu',
        props: ['navMenus'],
        data() {
            return {
                code: null
            }
        },
        created(){
            this.code = JSON.parse(sessionStorage.getItem("currentSystem")).code;
            console.log(this.navMenus);
        },
        methods: {
            clearParam(){
                this.$routerUtil.clearParam();
            }
        },
    }
</script>

<style>
    .navMenu {
        text-align: left;
    }

    /*隐藏文字*/
    .el-menu--collapse .el-submenu__title span {
        display: none;
    }

    /*隐藏 > */
    .el-menu--collapse .el-submenu__title .el-submenu__icon-arrow {
        display: none;
    }
</style>